<template>
  <div class="otto-login">
    <Logo class="otto-login__title" />
    <p class="otto-login__subtitle">CHOOSE A NEW PASSWORD</p>
    <p class="otto-password__copy">Make it a strong one! Your password should include both letters and numbers and be at least 8 characters long. </p>
    <form class="otto-login__form" v-on:submit.prevent="onSubmit">
      <p v-if="this.errorMsg" class="otto-text-error">{{errorMsg}}</p>
      <div class="otto-login__field">
        <label class="otto-login__label">PASSWORD *</label>
        <input
          class="otto-login__input"
          type="password"
          v-model="password"
          @focus="onPasswordFocus()"
          v-bind:class="{'otto-login__input--error': $v.password.$error}">
        <span v-if="$v.password.$error && !$v.password.minLength" class="otto-text-error">The password you entered is too short.</span>
        <span v-if="$v.password.$error && !$v.password.passwordValidator" class="otto-text-error">Your password should include both letters and numbers.</span>
        <span v-if="$v.password.$error && !$v.password.required" class="otto-text-error">Please enter your password.</span>
      </div>
      <div class="otto-login__field">
        <label class="otto-login__label">RE-ENTER PASSWORD *</label>
        <input
          class="otto-login__input"
          type="password"
          v-model="password2"
          v-bind:class="{'otto-login__input--error': $v.password2.$error}"
          @focus="onPassword2Focus()"
        >
        <span v-if="$v.password2.$error && !$v.password2.required" class="otto-text-error">Please enter your password.</span>
        <span v-if="$v.password2.$error && !$v.password2.sameAs" class="otto-text-error">Make sure to enter the same password again.</span>
      </div>
     <button :disabled="submitting" :class="{'otto-btn--disabled': submitting}" class="otto-login__btn otto-login__btn--change-password"><span class="otto-btn-text">CHANGE PASSWORD</span></button>
    </form>
  </div>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import Logo from './Logo.svg';


const passwordValidator = value => (/\d/.test(value) && /[a-zA-Z]/.test(value));

export default {
  name: 'change_password',
  components: {
    Logo,
  },
  data() {
    return {
      password2: '',
      password: '',
      errorMsg: '',
      submitting: false,
    };
  },
  validations: {
    password2: {
      required,
      sameAs: sameAs('password'),
      minLength: minLength(8),
    },
    password: {
      passwordValidator,
      required,
      minLength: minLength(8),
    },
  },
  methods: {
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE,
    }),
    onPassword2Focus() {
      this.errorMsg = '';
      this.$v.password2.$reset();
    },
    onPasswordFocus() {
      this.errorMsg = '';
      this.$v.password.$reset();
      this.$v.password2.$reset();
    },
    onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        this.submitting = true;
        this.changePassword();
      }
    },
    showError(err) {
      this.errorMsg = err.message || err;
    },
    changePassword() {
      const payload = {
        email: this.$route.query.email,
        password: this.password,
        resetCode: this.$route.query.code,
      };

      this.$store.dispatch('resetPassword', payload)
        .then(() => {
          this.submitting = false;
          this.$router.replace('login');
          this.addToast({
            text: 'Password has been changed successfully.',
            type: 'success',
          });
        })
        .catch((err) => {
          console.log('errror', err);
          this.submitting = false;
          this.showError(err);
        });
    },
  },
};
</script>
<style lang="sass" src="@/assets/styles/login.sass"></style>
<style lang="sass" src="@/assets/styles/password.sass"></style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue